import { FC, PropsWithChildren } from "react";
import useDataInitializer from "../hooks/useDataInitializer";
import useUserApi from "../http/user/api";
import styles from "./UserInitials.module.css";

type UserInitialsProps = {
  lastName: string;
  firstName: string;
  userId?: string;
};

const UserInitials: FC<UserInitialsProps> = ({ firstName, lastName, userId }) => {
  const initials = `${lastName?.[0] ?? ""}${firstName?.[0] ?? ""}`.toUpperCase();

  return (
    <div title={`${lastName} ${firstName}`} className={styles["avatar"]}>
      {userId ? <UserPicture userId={userId}>{initials}</UserPicture> : initials}
    </div>
  );
};

type UserPictureProps = PropsWithChildren<{
  userId: string;
}>;

const UserPicture: FC<UserPictureProps> = ({ userId, children }) => {
  const usersApi = useUserApi();

  const response = usersApi.useUserProfilePicture(userId);
  const [picture] = useDataInitializer(response.data, response.error);

  return picture ? <img className={styles["user-picture"]} src={"data:image/jpeg;base64," + picture} /> : children;
};

export default UserInitials;
